import { type EventStandardDefs } from '@solinkcorp/event-standard';
import { getLanguageCode } from '@solinkcorp/locale';
import { getReduxStore } from 'stores/store';
import { i18nEventFieldName } from 'utils/EventUtil';
import { FixedWidthFieldRenderer } from './base';
import { type FieldRendererField, type FieldValue } from './types';

export class EnumFieldRenderer extends FixedWidthFieldRenderer {
  static makeTemplateContextStatic(
    eventStandard: EventStandardDefs,
    fieldName: string,
    fieldValue: FieldValue | FieldValue[],
    fieldMetadata: FieldRendererField,
  ): { fieldName: string; fieldValue: string | string[] } {
    const localeCode = getReduxStore().getState().localeState.localeCode;
    const lang = getLanguageCode(localeCode);
    const getVal = (v: FieldValue) =>
      fieldMetadata.i18n?.[lang]?.values?.[`${v}`] ?? fieldMetadata.i18n?.en.values?.[`${v}`] ?? '';

    if (Array.isArray(fieldValue)) {
      return {
        fieldName: i18nEventFieldName(fieldName, false, eventStandard),
        fieldValue: fieldValue.map(getVal),
      };
    }
    return {
      fieldName: i18nEventFieldName(fieldName, false, eventStandard),
      fieldValue: getVal(fieldValue),
    };
  }
}
